"use strict";
(self["webpackChunkbranch_basics"] = self["webpackChunkbranch_basics"] || []).push([[8349],{

/***/ 8349:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ BlogDashboard)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function BlogDashboard({ wrapper }) {
  const settings = {
    filter: '[data-hook="blog-filter-item"]',
    blogPost: '[data-hook="blog-card"].tw-hidden',
    loader: '[data-hook="spinning-loader"]',
    
    images: '[data-hook="blog-post-content-wrapper"] img',
    anchorTags: '[data-hook="blog-post-content-wrapper"] a'
  }


  ;(function init(){
    initializeEventListeners();
    fixBlogImages();
    fixBlogLinks();
  })()


  function fixBlogImages(){
    // normalizes height, width, style attributes on RTE image
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.images).attr('height', '').attr('width', '').attr('style', '');
  }


  function fixBlogLinks() {
    // Sets any anchor tag within the blog to open in a new window by default
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.anchorTags).attr('target','_blank');
  }


  function updateFilter(e){
    e.preventDefault();
    let filterBy = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data("tag");
    let currentPath = window.location.href;

    if (currentPath.includes("/tagged/")) {
      // Updating an existing filter
      if (currentPath.includes("?")) {
        // split at tagged + split at params
        let params = currentPath.split("?");
        let basePath = currentPath.split("/tagged/")

        window.location.href = basePath[0] + "/tagged/" + filterBy + "?" + params[1];
  
      } else {
        let basePath = currentPath.split("/tagged")
        window.location.href = basePath[0] + "/tagged/" + filterBy;
      }
    } else {
      // Setting an initial filter
      if (currentPath.includes("?")) {
        // split at params
        let path = currentPath.split("?");
        window.location.href = path[0] + "/tagged/" + filterBy + "?" + path[1];
      } else {
        window.location.href = currentPath + "/tagged/" + filterBy;
      }
    }

  }


  function updatePosts (){
    let $articles = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.blogPost).slice(0, 16);
    setTimeout( function() {
      $articles.removeClass("tw-hidden");
    }, 2000);

    console.log("trying to updatePosts -> $articles: ", $articles)

    if ($articles.length === 0) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.loader).addClass('tw-hidden');
    }
  }


  function initializeEventListeners(){
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.filter).click(updateFilter);

    let loader = document.querySelector(settings.loader);
    if (loader) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('scroll', function(){
        if ((loader.getBoundingClientRect().y - window.innerHeight) < -120 ) {
          updatePosts();
        }
      });
    }
  }



};

/***/ })

}]);